import Image from "next/image";
import { useState } from "react";
import styles from "./UseCases.module.scss";

const cases = [
	{
		btn: "page_illustration_block3_but1",
		description: "page_illustration_descriptor3",
		picsArr: [
			{ src: "1-1.jpg", id: 1 },
			{ src: "1-2.jpg", id: 2 },
			{ src: "1-3.jpg", id: 3 },
			{ src: "1-4.jpg", id: 4 },
			{ src: "1-5.jpg", id: 5 },
			{ src: "1-6.jpg", id: 6 },
			{ src: "1-7.jpg", id: 7 },
			{ src: "1-8.jpg", id: 8 },
			{ src: "1-9.jpg", id: 9 },
		],
	},
	{
		btn: "page_illustration_block3_but2",
		description: "page_illustration_descriptor3",
		picsArr: [
			{ src: "2-1.jpg", id: 10 },
			{ src: "2-2.jpg", id: 11 },
			{ src: "2-3.jpg", id: 12 },
			{ src: "2-4.jpg", id: 13 },
			{ src: "2-5.jpg", id: 14 },
			{ src: "2-6.jpg", id: 15 },
			{ src: "2-7.jpg", id: 16 },
			{ src: "2-8.jpg", id: 17 },
			{ src: "2-9.jpg", id: 18 },
			{ src: "2-10.jpg", id: 19 },
		],
	},
	{
		btn: "page_illustration_block3_but3",
		description: "page_illustration_descriptor3",
		picsArr: [
			{ src: "3-1.jpg", id: 20 },
			{ src: "3-2.jpg", id: 21 },
			{ src: "3-3.jpg", id: 22 },
			{ src: "3-4.jpg", id: 23 },
			{ src: "3-5.jpg", id: 24 },
			{ src: "3-6.jpg", id: 25 },
			{ src: "3-7.jpg", id: 26 },
			{ src: "3-8.jpg", id: 27 },
			{ src: "3-9.jpg", id: 28 },
			{ src: "3-10.jpg", id: 29 },
		],
	},
	{
		btn: "page_illustration_block3_but4",
		description: "page_illustration_descriptor3",
		picsArr: [
			{ src: "4-1.jpg", id: 30 },
			{ src: "4-2.jpg", id: 31 },
			{ src: "4-3.jpg", id: 32 },
			{ src: "4-4.jpg", id: 33 },
			{ src: "4-5.jpg", id: 34 },
			{ src: "4-6.jpg", id: 35 },
			{ src: "4-7.jpg", id: 36 },
			{ src: "4-8.jpg", id: 37 },
			{ src: "4-9.jpg", id: 38 },
		],
	},
];

const UseCases = ({ dictionary }) => {
	const [activeCase, setActiveCase] = useState(cases[0]);

	const handleChangeCase = (index) => {
		setActiveCase(cases[index]);
	};

	return (
		<section className={styles.container}>
			<h2 className={styles.title}>{dictionary["page_illustration_h3"] || "Bring your own sketches to life"}</h2>

			<p className={styles.description}>{dictionary[activeCase.description] || activeCase.description}</p>

			<div className={styles.btns_wrapper}>
				{cases.map(({ btn }, index) => (
					<button onMouseEnter={() => handleChangeCase(index)} key={btn} className={`${styles.btn} ${btn === activeCase.btn ? styles.active : styles.not_active}`}>
						{dictionary[btn] || btn}
					</button>
				))}
			</div>

			<div className={styles.photo_wrapper}>
				{activeCase.picsArr.map((item, idx) => (
					<Image
						key={item.id}
						src={`/illustration_service/cases/${item.src}`}
						alt={`${dictionary[activeCase.btn] || activeCase.btn} example`}
						width="500"
						height="500"
						className={`${styles.image} ${styles[`image${item.id}`]}`}
						loading="lazy"
						sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
						quality={80}
					/>
				))}
			</div>
		</section>
	);
};

export default UseCases;
